// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1fQ5E","productName":"Table_productName__bYbAJ"};